// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XKYWhcMBzIvWkPXfxFjS {
  display: block;
  position: absolute;
  bottom: -1%;
  border-radius: unset;
  z-index: -2;
  left: calc(var(--most-played-num-image-width) * -0.85);
  width: var(--most-played-num-image-width);
  height: var(--most-played-num-image-height);
  /* both digit images share the full box; the tens digit is shifted left via transform */
}
.XKYWhcMBzIvWkPXfxFjS img.AIl5h9JzHz0J0L7dabsw {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
/*
  each card is pushed far enough for its own number to show, plus a small gap to the
  previous card. --top-number-left (set by Game) is where the visible number starts,
  as a fraction of the image width - see topGamesDigits.ts
*/
.edD9zUlhiXqdBXcZc0Uw.Hh0s_fYL1zxEWsSbzFrR {
  margin-left: calc(var(--most-played-num-image-width) * (0.87 - var(--top-number-left, 0.5)));
}
/*
  Exceptions
  we want specific spacing for the digit 1 at the end of a number
*/
.edD9zUlhiXqdBXcZc0Uw:first-child {
  margin-left: 10px;
}
.edD9zUlhiXqdBXcZc0Uw.Hh0s_fYL1zxEWsSbzFrR .XKYWhcMBzIvWkPXfxFjS[data-last-digit='1'] {
  left: calc(var(--most-played-num-image-width) * -0.85 + 1px);
}
@media (min-width: 576px) {
  .edD9zUlhiXqdBXcZc0Uw:first-child {
    margin-left: 12px;
  }
}
@media (min-width: 1026px) {
  .edD9zUlhiXqdBXcZc0Uw:first-child {
    margin-left: 36px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/components/GameCard/components/TopGamesNumbers/TopGamesNumbers.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,sDAAsD;EACtD,yCAAyC;EACzC,2CAA2C;EAC3C,uFAAuF;AACzF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;;;;CAIC;AACD;EACE,4FAA4F;AAC9F;AACA;;;CAGC;AACD;EACE,iBAAiB;AACnB;AACA;EACE,4DAA4D;AAC9D;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".TopGamesNumberContainer {\n  display: block;\n  position: absolute;\n  bottom: -1%;\n  border-radius: unset;\n  z-index: -2;\n  left: calc(var(--most-played-num-image-width) * -0.85);\n  width: var(--most-played-num-image-width);\n  height: var(--most-played-num-image-height);\n  /* both digit images share the full box; the tens digit is shifted left via transform */\n}\n.TopGamesNumberContainer img.digit {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n/*\n  each card is pushed far enough for its own number to show, plus a small gap to the\n  previous card. --top-number-left (set by Game) is where the visible number starts,\n  as a fraction of the image width - see topGamesDigits.ts\n*/\n.gameContainer.multi {\n  margin-left: calc(var(--most-played-num-image-width) * (0.87 - var(--top-number-left, 0.5)));\n}\n/*\n  Exceptions\n  we want specific spacing for the digit 1 at the end of a number\n*/\n.gameContainer:first-child {\n  margin-left: 10px;\n}\n.gameContainer.multi .TopGamesNumberContainer[data-last-digit='1'] {\n  left: calc(var(--most-played-num-image-width) * -0.85 + 1px);\n}\n@media (min-width: 576px) {\n  .gameContainer:first-child {\n    margin-left: 12px;\n  }\n}\n@media (min-width: 1026px) {\n  .gameContainer:first-child {\n    margin-left: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TopGamesNumberContainer": `XKYWhcMBzIvWkPXfxFjS`,
	"digit": `AIl5h9JzHz0J0L7dabsw`,
	"gameContainer": `edD9zUlhiXqdBXcZc0Uw`,
	"multi": `Hh0s_fYL1zxEWsSbzFrR`
};
export default ___CSS_LOADER_EXPORT___;
